import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5c881e56"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "sub_contents_wrap error" };
const _hoisted_2 = { class: "error_container maintenance" };
const _hoisted_3 = { class: "error_code" };
const _hoisted_4 = { class: "error_explanation" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('common.system_maintenance')), 1),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("small", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('message.apologize_inconvenience')) + ".", 1),
                    _hoisted_5,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('message.try_again_later')), 1)
                ])
            ])
        ])
    ]));
}
